















import { createComponent } from "@vue/composition-api";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { DRINKCHAT_LINK } from "@dcc/constants/links";
export default createComponent({
  setup() {
    const dictionary = useDictionary();

    return {
      ...dictionary,
      DRINKCHAT_LINK
    };
  }
});
